export const shippingMethodsList = ['self-billing', 'email', 'by post', 'portal'];
